import "./App.css";
import { PackageSelection, AssistAISection } from "./Views/PackageSelection";
import { PricingSelection } from "./Views/PricingBreakdown";
import { ViewSelection } from "./Views/ViewSelection";
import { SubscriptionBreakdown } from "./Views/SubscriptionBreakdown";
import { useState } from "react";


function App() {
  const [page, setPage] = useState("first");
  const [annualView, setAnnualView] = useState(true);
  const [sixMonthView, setSixMonthView] = useState(true);
  const [monthlyView, setMonthlyView] = useState(true);
  const [crmPackage, setCrmPackage] = useState(null);
  const [engageCard, setEngageCard] = useState(null);
  const [adminCount, setAdminCount] = useState(1);
  const [salesCount, setSalesCount] = useState(0);
  const [fieldCount, setFieldCount] = useState(0);
  const [subcontractorCount, setSubcontractorCount] = useState(0);
  const [showAssistAI, setShowAssistAI] = useState(false);
  const [expandedCrmCards, setExpandedCrmCards] = useState([]);
  const [expandedEngageCards, setExpandedEngageCards] = useState([]);
  const [expandedUserCards, setExpandedUserCards] = useState([]);
  const [additionalPackages, setAdditionalPackages] = useState([
    {
      name: "AssistAI",
      cost: 298,
      isSelected: false,
    },
    {
      name: "AI Message Recorder",
      cost: 98,
      isSelected: false,
    },
  ]);

  const selectPackage = (currentPackage) => {
    const updatedPackages = additionalPackages.map((p) => ({
      ...p,
      isSelected: p.name === currentPackage.name ? !p.isSelected : p.isSelected,
    }));

    setAdditionalPackages(updatedPackages);
  };

  return (
    <>
      {page === "first" && (
        <ViewSelection
          goToNextPage={() => {
            setPage("next");
          }}
          annualView={annualView}
          setAnnualView={setAnnualView}
          sixMonthView={sixMonthView}
          setSixMonthView={setSixMonthView}
          monthlyView={monthlyView}
          setMonthlyView={setMonthlyView}
        />
      )}
      {page === "next" && (
        <>
          <PackageSelection
            goToFirstPage={() => {
              setPage("first");
            }}
            crmPackage={crmPackage}
            setCrmPackage={setCrmPackage}
            engageCard={engageCard}
            setEngageCard={setEngageCard}
            adminCount={adminCount}
            setAdminCount={setAdminCount}
            salesCount={salesCount}
            setSalesCount={setSalesCount}
            fieldCount={fieldCount}
            setFieldCount={setFieldCount}
            subcontractorCount={subcontractorCount}
            setSubcontractorCount={setSubcontractorCount}
            showAssistAI={showAssistAI}
            setShowAssistAI={setShowAssistAI}
            expandedCrmCards={expandedCrmCards}
            setExpandedCrmCards={setExpandedCrmCards}
            expandedEngageCards={expandedEngageCards}
            setExpandedEngageCards={setExpandedEngageCards}
            expandedUserCards={expandedUserCards}
            setExpandedUserCards={setExpandedUserCards}
            additionalPackages={additionalPackages}
            selectPackage={selectPackage}
          />
          {showAssistAI && (
            <AssistAISection
              additionalPackages={additionalPackages}
              selectPackage={selectPackage}
              showAssistAI={showAssistAI}
              setShowAssistAI={setShowAssistAI}
            />
          )}
          <PricingSelection
            crmPackage={crmPackage}
            engageCard={engageCard}
            adminCount={adminCount}
            salesCount={salesCount}
            additionalPackages={additionalPackages}
            fieldCount={fieldCount}
            subcontractorCount={subcontractorCount}
            annualView={annualView}
            sixMonthView={sixMonthView}
            monthlyView={monthlyView}
          />
          <SubscriptionBreakdown
            crmPackage={crmPackage}
            engageCard={engageCard}
            adminCount={adminCount}
            salesCount={salesCount}
            fieldCount={fieldCount}
            subcontractorCount={subcontractorCount}
            additionalPackages={additionalPackages}
          />
        </>
      )}
    </>
  );
}

export default App;
